import DoctorsSection from '../../sections/DoctorsSection'
import FeaturesSection from '../../sections/FeaturesSection'
import FeedbackSection from '../../sections/FeedbackSection'
import HeroSection from '../../sections/HeroSection'
import LocationSection from '../../sections/LocationSection'
import ServicesSection from '../../sections/ServicesSection'
import StepsSection from '../../sections/StepsSection'
import SubscribeSection from '../../sections/SubscribeSection'
import { useEffect } from "react";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='HomePage'>
      <HeroSection />
      <StepsSection />
      <ServicesSection />
      <FeaturesSection />
      <DoctorsSection />
      <FeedbackSection />
      <SubscribeSection />
      <LocationSection />
    </div>
  )
}

export default HomePage
